module.exports = __webpack_public_path__ + "static/media/ph.j+y.background.799614a6.jpg";